var map = {
	"./Earth_Potion.png": "a60b",
	"./Fire_Potion.png": "ebdb",
	"./Lightning_Potion.png": "3ae9",
	"./Water_Potion.png": "fede",
	"./earth-45.png": "4e32",
	"./earth.png": "05ec",
	"./fire-45.png": "72c1",
	"./fire.png": "17c8",
	"./icon-earth.png": "b31f",
	"./icon-fire.png": "9051",
	"./icon-thunder.png": "085b",
	"./icon-water.png": "590d",
	"./lightning-45.png": "3916",
	"./lightning.png": "7860",
	"./rune_05_te.png": "212e",
	"./rune_05_te4.png": "1f1c",
	"./scroll_06_te.png": "46c2",
	"./scroll_06_te4.png": "ac99",
	"./w-icon-earth.png": "82db",
	"./w-icon-fire.png": "eb2c",
	"./w-icon-thunder.png": "7e97",
	"./w-icon-water.png": "ad7a",
	"./water-45.png": "75ca",
	"./water.png": "c79e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "88b9";